import { ArbitrumOne, BNBChain, Ethereum, Polygon, Tron, chains } from '@particle-network/chains';
const DIDSupportChains = [Ethereum, BNBChain, Polygon, ArbitrumOne, Tron];
/**
 * 当前支持 .eth .bit .bnb .arb
 * @param did
 * @returns boolean
 */
export const isValidDID = (did) => {
    return /^(?!\s*\.(eth|bit|bnb|arb)$).+\.(eth|bit|bnb|arb)$/.test(did);
};
export const isChainSupportDID = (chain) => {
    if (!chain.id) {
        return false;
    }
    const chainInfo = chains?.getChainInfo?.(chain);
    return chainInfo != undefined && DIDSupportChains.includes(chainInfo);
};
//# sourceMappingURL=didUtils.js.map